import React, { useEffect } from "react"
import OnlineCourses from "../allcourses/OnlineCourses"
import Heading from "../common/heading/Heading"
import "../allcourses/courses.css"
import { coursesCard } from "../../dummydata"
import { Link } from "react-router-dom"

const HAbout = ({ setName }) => {

  useEffect(() => {
    setName('');
  })

  return (
    <>
      <section className='homeAbout'>
        <div className='container'>
          <Heading subtitle='our offline courses' title='explore our popular courses' />

          <div className='coursesCard'>
            {/* copy code form  coursesCard */}
            <div className='grid2'>
              {coursesCard.slice(0, 3).map((val) => (
                <div className='items'>
                  <div className='content flex'>
                    <div className='left'>
                      <div className='img'>
                        <img src={val.cover} alt='' />
                      </div>
                    </div>
                    <div className='text'>
                      <h1>{val.coursesName}</h1>
                      <div className='rate'>
                        {/* <i className='fa fa-star'></i>
                        <i className='fa fa-star'></i>
                        <i className='fa fa-star'></i>
                        <i className='fa fa-star'></i>
                        <i className='fa fa-star'></i>
                        <label htmlFor=''>(5.0)</label> */}
                      </div>
                      <div className='details'>
                        {val.courTeacher.map((details) => (
                          <>
                            <div className='box'>
                              <div className='dimg'>
                                <img src={details.dcover} alt='' />
                              </div>
                              <div className='para'>
                                <h4>{details.name}</h4>
                              </div>
                            </div>
                            <br></br>
                            {val.sub.map((subs) => (
                              <>
                                < a href="" style={{ lineHeight: "30px", fontSize: "10px", color: "#3D48A6" }}>{'\u2B24'}</a>   <span> {subs}</span>
                                <br></br>
                              </>
                            ))}
                          </>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className='price'>
                    <h3>
                      {val.priceAll} / {val.pricePer}
                    </h3>
                  </div>
                  {/* <Link to='https://forms.gle/K8HsU9yKhFF8NAsB8' target="_blank" style={{ color: "#fff" }}>
                    <button className='outline-btn'>ENROLL NOW !</button>
                  </Link> */}
                  <a
                    href={`https://wa.me/919205038806?text=${encodeURIComponent(
                      `Hi, I’m interested in the ${val.coursesName} Course. Could you please share the course details, fees, duration, class schedule, and enrollment process? Thank you!`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#fff" }}
                  >
                    <button className="outline-btn">ENROLL NOW !</button>
                  </a>

                </div>
              ))}
            </div>
          </div>
        </div>
        <OnlineCourses />
      </section>
    </>
  )
}

export default HAbout
